/**
 * Bundled translation catalogs. One namespace per feature folder (`features/<domain>` + its routes),
 * `common` for vocabulary shared across pages (actions, statuses, roles, permissions, time) and
 * `shell` for navigation, breadcrumbs and the landing page. English is the source of truth: the
 * key union TypeScript checks `t()` against comes from the English files (see `i18next.d.ts`),
 * `scripts/check-locales.mjs` keeps Czech in lockstep.
 */
import csAudit from '../locales/cs/audit.json';
import csCommon from '../locales/cs/common.json';
import csContactUpdates from '../locales/cs/contactUpdates.json';
import csEnrichment from '../locales/cs/enrichment.json';
import csJobs from '../locales/cs/jobs.json';
import csLeads from '../locales/cs/leads.json';
import csPerformance from '../locales/cs/performance.json';
import csPipeline from '../locales/cs/pipeline.json';
import csProjects from '../locales/cs/projects.json';
import csPublish from '../locales/cs/publish.json';
import csReview from '../locales/cs/review.json';
import csSchedules from '../locales/cs/schedules.json';
import csSegmentation from '../locales/cs/segmentation.json';
import csShell from '../locales/cs/shell.json';
import csUsers from '../locales/cs/users.json';
import enAudit from '../locales/en/audit.json';
import enCommon from '../locales/en/common.json';
import enContactUpdates from '../locales/en/contactUpdates.json';
import enEnrichment from '../locales/en/enrichment.json';
import enJobs from '../locales/en/jobs.json';
import enLeads from '../locales/en/leads.json';
import enPerformance from '../locales/en/performance.json';
import enPipeline from '../locales/en/pipeline.json';
import enProjects from '../locales/en/projects.json';
import enPublish from '../locales/en/publish.json';
import enReview from '../locales/en/review.json';
import enSchedules from '../locales/en/schedules.json';
import enSegmentation from '../locales/en/segmentation.json';
import enShell from '../locales/en/shell.json';
import enUsers from '../locales/en/users.json';

export const LANGUAGES = ['en', 'cs'] as const;
export type Language = (typeof LANGUAGES)[number];

export const resources = {
  en: {
    common: enCommon,
    shell: enShell,
    pipeline: enPipeline,
    review: enReview,
    jobs: enJobs,
    enrichment: enEnrichment,
    publish: enPublish,
    contactUpdates: enContactUpdates,
    segmentation: enSegmentation,
    projects: enProjects,
    users: enUsers,
    audit: enAudit,
    schedules: enSchedules,
    performance: enPerformance,
    leads: enLeads,
  },
  cs: {
    common: csCommon,
    shell: csShell,
    pipeline: csPipeline,
    review: csReview,
    jobs: csJobs,
    enrichment: csEnrichment,
    publish: csPublish,
    contactUpdates: csContactUpdates,
    segmentation: csSegmentation,
    projects: csProjects,
    users: csUsers,
    audit: csAudit,
    schedules: csSchedules,
    performance: csPerformance,
    leads: csLeads,
  },
} as const;

export type Namespace = keyof (typeof resources)['en'];
export const NAMESPACES = Object.keys(resources.en) as Namespace[];
